import { SiteFieldNames } from '@lib/enums/fieldNames/siteFieldNames';

export default function getAreaEmptyDefaultValues() {
  return {
    [SiteFieldNames.Name]: '',
    [SiteFieldNames.Code]: '',
    [SiteFieldNames.Address]: '',
    [SiteFieldNames.Description]: '',
    [SiteFieldNames.DocumentationLinks]: [],
    [SiteFieldNames.PoorWifi]: false,
  };
}
